import { Link, NavLink } from "react-router-dom";
import { ArrowUpRight, Instagram, Facebook } from "lucide-react";

export const Navbar = () => {
  const linkBase = "text-sm font-medium tracking-wide transition-colors";
  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#f5f1e8]/80 border-b border-[#d4cdb8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="flex items-center"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_stripe-booking-hub-2/artifacts/e4dtleyr_Dnilasor.PNG"
            alt="Dnilasor Family Corporation"
            className="h-16 w-auto"
          />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <NavLink
            to="/#services"
            data-testid="nav-services"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-[#0F1A36]" : "text-[#5c5a56] hover:text-[#0F1A36]"}`
            }
          >
            Services
          </NavLink>
          <NavLink
            to="/#bundles"
            data-testid="nav-bundles"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? "text-[#0F1A36]" : "text-[#5c5a56] hover:text-[#0F1A36]"}`
            }
          >
            Bundles
          </NavLink>
        </nav>
        <Link
          to="/#services"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center gap-2 text-sm font-medium text-[#0F1A36] hover:text-[#C9A961] transition-colors"
        >
          Start with an audit <ArrowUpRight className="w-4 h-4" />
        </Link>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#0F1A36] text-[#f5f1e8] mt-32"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
      <div className="overline !text-[#C9A961] mb-8">Sacramento, CA · 2026</div>
      <h2 className="font-display font-bold leading-none tracking-tight text-[14vw] md:text-[8vw]">
        Let&rsquo;s build
        <br />
        what works.
      </h2>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-[#f5f1e8]/70">
        <div>
          <div className="overline !text-[#C9A961] mb-3">Email</div>
          <a
            href="mailto:david@dnilasor.com"
            data-testid="footer-email"
            className="hover:text-[#C9A961] transition-colors"
          >
            david@dnilasor.com
          </a>
        </div>
        <div className="md:col-span-2">
          <div className="overline !text-[#C9A961] mb-3">Follow us</div>
          <p className="mb-4 text-[#f5f1e8]/80 max-w-md leading-relaxed">
            Like and follow to get notified about new offers, case studies,
            and AI tips for SMBs.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/dnilasorfamily/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              aria-label="Follow Dnilasor Family on Instagram"
              className="inline-flex items-center gap-2 border border-[#f5f1e8]/20 px-4 py-2.5 hover:border-[#C9A961] hover:text-[#C9A961] transition-colors"
            >
              <Instagram className="w-4 h-4" />
              <span className="font-display text-sm">Instagram</span>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61590388183652"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="Like Dnilasor Family on Facebook"
              className="inline-flex items-center gap-2 border border-[#f5f1e8]/20 px-4 py-2.5 hover:border-[#C9A961] hover:text-[#C9A961] transition-colors"
            >
              <Facebook className="w-4 h-4" />
              <span className="font-display text-sm">Facebook</span>
            </a>
          </div>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 text-xs text-[#f5f1e8]/50">
        © 2026 Dnilasor Family Corporation. All rights reserved.
      </div>
    </div>
  </footer>
);
